import { render, staticRenderFns } from "./CancelDeleteAccount.vue?vue&type=template&id=6b042c05&scoped=true&"
import script from "./CancelDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./CancelDeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./CancelDeleteAccount.vue?vue&type=style&index=0&id=6b042c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b042c05",
  null
  
)

export default component.exports